/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Html_Studio_TitleInputs */

const cs_builder_html_studio_title = /** @type {(inputs: Builder_Html_Studio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plátno dokumentu`)
};

const en_builder_html_studio_title = /** @type {(inputs: Builder_Html_Studio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document canvas`)
};

/**
* | output |
* | --- |
* | "Document canvas" |
*
* @param {Builder_Html_Studio_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_html_studio_title = /** @type {((inputs?: Builder_Html_Studio_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Html_Studio_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_html_studio_title(inputs)
	return cs_builder_html_studio_title(inputs)
});